import React from 'react';

import { ApInput } from '@alixpartners/ui-components';

import { Select } from 'Settings/Select';

import {
	Wrapper,
	Title,
	Description,
	BodyWrapper,
	SelectWrapper,
	Label,
} from './TailSpendRecurrence.styles';

const PERIOD_OPTIONS = [{ key: 1, value: 'Month' }, { key: 2, value: 'Years' }];

export const TailSpendRecurrence = ({ periodType, periodValue, onChange }) => {
	const selectedPeriodOption =
		PERIOD_OPTIONS.find(option => option.key === periodType) ||
		PERIOD_OPTIONS[0];

	const handlePeriodTypeChange = event => {
		const selectedPeriodOption = PERIOD_OPTIONS.find(
			({ value }) => value === event.target.value
		);

		onChange({ periodType: selectedPeriodOption.key });
	};
	const defaultPeriodValue = selectedPeriodOption.key === 1 ? 12 : 1;

	const handlePeriodValueChange = periodValue => {
		onChange({ periodValue: +periodValue || defaultPeriodValue });
	};

	return (
		<Wrapper>
			<Title>Vendor recurrence period</Title>
			<Description>
				Determines how far back to look in the available data, prior to your
				selected time period, for previous spend with tail vendors.
			</Description>
			<BodyWrapper>
				<Label>Previous</Label>
				<ApInput
					type="number"
					name="value"
					autoComplete="off"
					onChange={handlePeriodValueChange}
					defaultValue={periodValue || defaultPeriodValue}
					shouldStopPropagation
				/>
				<SelectWrapper>
					<Select
						name="categoryUnit"
						options={PERIOD_OPTIONS}
						value={selectedPeriodOption.value}
						onChange={handlePeriodTypeChange}
					/>
				</SelectWrapper>
			</BodyWrapper>
		</Wrapper>
	);
};
